import { render, staticRenderFns } from "./liProduct.vue?vue&type=template&id=66fbeba4&scoped=true"
import script from "./liProduct.vue?vue&type=script&lang=js"
export * from "./liProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fbeba4",
  null
  
)

export default component.exports